import { render, staticRenderFns } from "./CommunityProjectDetail.vue?vue&type=template&id=2a9bc1cf&scoped=true&"
import script from "./CommunityProjectDetail.vue?vue&type=script&lang=js&"
export * from "./CommunityProjectDetail.vue?vue&type=script&lang=js&"
import style0 from "./CommunityProjectDetail.vue?vue&type=style&index=0&id=2a9bc1cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9bc1cf",
  null
  
)

export default component.exports